import React, { useState, useEffect, useRef } from "react";
import { getDatabase, ref, push, onValue } from "firebase/database"; 
import { getItemFromLocalStorage } from "../../../utils"; 
import { app } from "../../firebase"; 
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import { useNavigate } from 'react-router-dom';
import leftarrow from '../../../safreeimg/left-arrow.png';

const Chat = () => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const navigate = useNavigate();
  const db = getDatabase(app);
  const profileData = JSON.parse(localStorage.getItem('profile'));
  const messagesEndRef = useRef(null); 

  const hash = window.location.hash.substring(1);
  const [alarmID, queryString] = hash.split("?");
  const queryParams = new URLSearchParams(queryString);
  const senderName = profileData?.name || "Unknown";
  const senderImage = profileData?.profileImage || "";

  const chat_id = getItemFromLocalStorage("token");

  console.log("Extracted Data:", { alarmID, senderName, senderImage });
  console.log("Chat ID from localStorage:", chat_id);

  useEffect(() => {
    if (!alarmID) return;

    const chatRef = ref(db, `messages/${alarmID}`);

    const unsubscribe = onValue(chatRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const messagesArray = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        setMessages(messagesArray);
      } else {
        setMessages([]);
      }
    });

    return () => unsubscribe(); 
  }, [db, alarmID]);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  const sendMessage = async () => {
    if (newMessage.trim() === "") return;

    const messageData = {
      alarmID,
      chat_id,
      message: newMessage,
      senderImage,
      senderName,
      timestamp: String(Math.floor(new Date().getTime() / 1000)),
    };

    console.log("Message Data being sent to Firebase:", messageData);

    await push(ref(db, `messages/${alarmID}`), messageData);

    setNewMessage("");
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className='container user-management'>
      <div className='row header'>
        <div className='col-md-6'>
          <p className='sub-heading'><img onClick={handleBackClick} className="back-button" src={leftarrow} alt="" /> Chat Management</p>
        </div>
      </div>
      <div className="chat-container">
        <div className="messages">
          {messages.map((msg) => (
            <div key={msg.id} className={`message ${msg.chat_id === chat_id ? "sent" : "received"}`}>
              <img src={msg.senderImage} alt={msg.senderName} className="avatar" />
              <div className="content">
                <p className="sender-name">{msg.senderName}</p>
                <p className="text">{msg.message}</p>
                <span className="timestamp">
                  {msg.timestamp ? new Date(msg.timestamp * 1000).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false
                  }) : "..."}
                </span>
              </div>
            </div>
          ))}
          {/* Empty div to auto-scroll */}
          <div ref={messagesEndRef} />
        </div>
        <div className="input-box">
          <input
            type="text"
            placeholder="Type a message..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                sendMessage();
              }
            }}
          />
          <button onClick={sendMessage}>Send</button>
        </div>
      </div>
    </div>
  );
};

export default Chat;
